<template>
  <v-sheet class="slider-wrapper" elevation="6">
    <v-slide-group v-model="model" class="mt-2" show-arrows center-active>
      <v-slide-item
        elevation="6"
        class="mt-6"
        v-for="item in QrTypes"
        :key="item.value"
        v-slot="{ toggle }"
      >
        <v-badge
          :value="['Business', 'bShop'].includes(item.value)"
          content="به زودی"
          color="red"
          overlap
          offset-x="30"
          offset-y="30"
          class="ma-2"
        >
          <v-card
            :class="{
              'disabled-item': ![
                'visitCard',
                'labelproduct',
                'singleProduct',
              ].includes(item.value),
            }"
            class="text-center"
            width="100"
            height="70"
            outlined
            flat
            :style="{
              background: `linear-gradient(to bottom left, ${item.colors[0]}, ${item.colors[1]}, ${item.colors[2]})`,
            }"
            :ripple="false"
            elevation="6"
            :disabled="
              !['visitCard', 'labelproduct', 'singleProduct'].includes(
                item.value,
              )
            "
            @click="handleSelection(item, toggle)"
          >
            <div class="main-circle">
              <v-avatar
                size="40"
                :style="{
                  background: `linear-gradient(to bottom right, white, ${item.colors[2]})`,
                }"
                elevation="6"
              >
                <v-icon :color="item.colors[0]" size="20"
                  >mdi-{{ item.icon }}</v-icon
                >
              </v-avatar>
            </div>

            <v-card-text
              class="text-box mt-3"
              style="height: 52%; justify-content: center"
            >
              <div
                class="text-title"
                style="justify-content: center; padding-top: 10%"
                :style="{
                  color: `${item.colors[0]}`,
                }"
              >
                {{ item.name }}
              </div>
            </v-card-text>
          </v-card>
        </v-badge>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
export default {
  name: "QrTypeCard",
  data() {
    return {
      QrTypes: [],
      selectedType: null,
      model: null,
    };
  },
  mounted() {
    this.QrTypes = this.getQrTypes();
  },
  methods: {
    handleSelection(item, toggle) {
      if (["visitCard", "labelproduct", "singleProduct"].includes(item.value)) {
        this.$emit("selectQr", item.value);
        this.selectedType = item;
        toggle();
      }
    },
    getQrTypes() {
      return [
        {
          value: "instagram",
          name: "اینستاگرام",
          icon: "instagram",
          colors: ["#E4405F", "#F77737", "#FCAF45"],
        },
        {
          value: "visitCard",
          name: "کارت ویزیت",
          icon: "card-account-details",
          colors: ["#3F51B5", "#7986CB", "#C5CAE9"],
        },
        {
          value: "appointment",
          name: "نوبت‌دهی",
          icon: "calendar-month",
          colors: ["#4CAF50", "#81C784", "#C8E6C9"],
        },
        {
          value: "insurance",
          name: "بیمه آنلاین",
          icon: "shield-account-outline",
          colors: ["#2196F3", "#64B5F6", "#BBDEFB"],
        },
        {
          value: "Business",
          name: "کسب و کار",
          icon: "store",
          colors: ["#FF9800", "#FFB300", "#FFE082"],
        },
        {
          value: "Commericial",
          name: "سایت مجتمع تجاری/اداری",
          icon: "office-building-outline",
          colors: ["#607D8B", "#90A4AE", "#CFD8DC"],
        },
        {
          value: "labelproduct",
          name: "لیبل محصول",
          icon: "tag-multiple",
          colors: ["#009688", "#4DB6AC", "#B2DFDB"],
        },
        {
          value: "bShop",
          name: "صفحه فروشگاهی",
          icon: "storefront",
          colors: ["#F44336", "#E57373", "#FFCDD2"],
        },
        {
          value: "SocialMedia",
          name: "شبکه های اجتماعی",
          icon: "comment-account",
          colors: ["#9C27B0", "#BA68C8", "#E1BEE7"],
        },
        {
          value: "VideoGallery",
          name: "گالری ویدئو",
          icon: "video",
          colors: ["#D81B60", "#F06292", "#F8BBD0"],
        },
        {
          value: "PhotoGallery",
          name: "گالری عکس",
          icon: "image",
          colors: ["#FFC107", "#FFD54F", "#FFECB3"],
        },
        {
          value: "singleProduct",
          name: "معرفی محصول",
          icon: "package",
          colors: ["#795548", "#A1887F", "#D7CCC8"],
        },
        {
          value: "menu",
          name: "منو",
          icon: "book-open-outline",
          colors: ["#00BCD4", "#4DD0E1", "#B2EBF2"],
        },
        {
          value: "text",
          name: "متن",
          icon: "card-text-outline",
          colors: ["#616161", "#9E9E9E", "#E0E0E0"],
        },
      ];
    },
  },
};
</script>

<style scoped>
.slider-wrapper {
  width: 100%;
}

.v-slide-group {
  width: 100%;
  overflow: hidden;
}

.main-circle {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.text-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #f5f5f5;
  border-radius: 4px;
  padding: 4px 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  width: 90%;
  text-align: center;
}

.text-title {
  font-size: 10px;
  font-weight: bold;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.disabled-item {
  opacity: 0.5 !important;
  pointer-events: none !important;
}

.v-card {
  position: relative;
  transition: transform 0.2s ease-out;
}

.v-card:hover:not(.disabled-item) {
  transform: translateY(-2px);
  box-shadow: 0 5px 9px rgba(0, 0, 0, 0.2);
}
</style>
